import { customerApiEndpoints } from '@/api/endpoints';
import { AntButton } from '@/common/ant-components/AntButton';
import { useFetch } from '@/hooks';
import { rules } from '@/utils/validation/FormValidation';
import { Col, Form, Input, Modal, Row, Select } from 'antd';
import { useEffect } from 'react';
import { useCreateCompanyLimits } from './query/useCompanyLimits';
import { useMutateGetApi } from '@/apiError/apiShow';
import { useUpdateApi } from '@/apiError/apiUpdate';

const CompanyLimitModal = ({
  isOpen,
  setIsOpen,
  refetch,
  id = null,
  setEditReferenceId,
  limits,
}) => {
  const [form] = Form.useForm();
  const { data } = useFetch(customerApiEndpoints.superAdminRetrieveList);

  const usersOptions =
    data.map((user) => ({
      value: user.referenceId,
      label: `${user.firstName} ${user.lastName}`,
    })) || [];
  const { mutateAsync } = useCreateCompanyLimits();

  const { mutateAsync: getDataById } = useMutateGetApi();
  const { mutateAsync: updateDataById } = useUpdateApi();

  const handleSubmit = async (values) => {
    try {
      if (!id) {
        mutateAsync(values, {
          onSuccess: () => {
            setIsOpen(false); // Close modal only after successful submission
            form.resetFields(); // Reset form fields after submission
            setEditReferenceId(null);
            refetch();
          },
        });
      } else {
        await updateDataById({
          url: `/superadmin/company/limits/${id}/`,
          values,
        });
        form.resetFields();
        setEditReferenceId(null);
      }

      setIsOpen(false);
      refetch();
    } catch (error) {
      console.error('Submission failed:', error);
    }
  };

  async function fetchData() {
    try {
      const res = await getDataById({
        url: `/superadmin/company/limits/${id}/`,
      });
      res?.data && form.setFieldsValue(res?.data);
    } catch (error) {
      console.error('Data Fetch failed:', error);
    }
  }
  useEffect(() => {
    if (id && isOpen) {
      fetchData();
    }
  }, [id, isOpen]);

  return (
    <div>
      <Modal
        open={isOpen}
        size="large"
        width={800}
        onCancel={() => {
          setIsOpen(false);
          form.resetFields(); // Reset form on cancel
          setEditReferenceId(null);
        }}
        title={id ? 'Udate' : 'Create'}
        destroyOnClose
        footer={[
          <AntButton
            key="back"
            onClick={() => {
              setIsOpen(false);
              form.resetFields(); // Reset form on cancel
              setEditReferenceId(null);
            }}
            style={{ marginRight: 8 }}
            color="red"
          >
            Cancel
          </AntButton>,
          <AntButton
            key="submit"
            type="primary" // Make submit button primary for better UX
            onClick={() => form.submit()} // Trigger form submission
          >
            {id ? 'Update' : 'Submit'}
          </AntButton>,
        ]}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit} // Add onFinish handler
        >
          <Row gutter={[16, 16]}>
            <Col xs={{ span: 24 }} lg={{ span: 8 }}>
              <Form.Item
                name="adminId"
                label="Admin User"
                rules={rules.required}
                hasFeedback
              >
                <Select
                  placeholder="Select Admin"
                  options={usersOptions}
                ></Select>
              </Form.Item>
            </Col>

            <Col xs={{ span: 24 }} lg={{ span: 8 }}>
              <Form.Item
                name="maxCompanies"
                label="Max Company"
                rules={rules.numberOnly}
                hasFeedback
              >
                <Input placeholder="Max No of Company" />
              </Form.Item>
            </Col>
            <Col xs={{ span: 24 }} lg={{ span: 8 }}>
              <Form.Item
                name="maxUsers"
                label="Max Users"
                rules={rules.numberOnly}
                hasFeedback
              >
                <Input placeholder="Max No of User" />
              </Form.Item>
            </Col>
            <Col xs={{ span: 24 }} lg={{ span: 8 }}>
              <Form.Item
                name="maxBranches"
                label="Max Branches"
                rules={rules.numberOnly}
                hasFeedback
              >
                <Input placeholder="Max No of Branches" />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </div>
  );
};

export default CompanyLimitModal;
